import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/x-circle.svg'


const _withScopeId = n => (_pushScopeId("data-v-14a5750c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "email-input-container" }
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 0,
  class: "required"
}
const _hoisted_4 = ["name", "placeholder", "disabled", "value", "onBlur"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "loading",
  width: "48",
  height: "16",
  viewBox: "0 0 48 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "8",
  r: "3",
  fill: "#dfe1e6"
}, null, -1 /* HOISTED */))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "24",
  cy: "8",
  r: "3",
  fill: "#00479d"
}, null, -1 /* HOISTED */))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "36",
  cy: "8",
  r: "3",
  fill: "#dfe1e6"
}, null, -1 /* HOISTED */))
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: $props.name
        }, [
          _createElementVNode("span", null, _toDisplayString($props.label), 1 /* TEXT */),
          ($props.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
            : _createCommentVNode("v-if", true)
        ], 8 /* PROPS */, _hoisted_2))
      : _createCommentVNode("v-if", true),
    _createVNode($setup["Field"], {
      name: $props.name,
      rules: $props.rules,
      type: "email",
      modelValue: $setup.emailValue,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.emailValue) = $event))
    }, {
      default: _withCtx(({ errorMessage: validationErrorMsg, handleBlur, meta }) => [
        _createElementVNode("div", {
          class: _normalizeClass(["text-input", {
          error: $setup.isError(meta, validationErrorMsg),
          disabled: $props.disabled,
        }])
        }, [
          _createElementVNode("input", {
            ref: "inputField",
            class: "input--base wizdome-custom",
            name: $props.name,
            type: "email",
            placeholder: $props.placeholder,
            disabled: $props.disabled,
            value: $setup.inputValue,
            onInput: $setup.onInput,
            onChange: $setup.onChange,
            onFocus: $setup.onFocused,
            onBlur: ($event: any) => ([handleBlur(), $setup.onBlurred()]),
            "aria-hidden": "true"
          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_4),
          ($setup.shouldShowClearButton)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "img-clear-text",
                src: _imports_0,
                onClick: $setup.clearText,
                onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
                "aria-hidden": "true"
              }, null, 32 /* NEED_HYDRATION */))
            : _createCommentVNode("v-if", true),
          ($props.certRequired)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                ($props.isLoading)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_6, [..._hoisted_10]))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      ref: "button",
                      class: _normalizeClass(["btn", { focuse: $setup.isFocused }]),
                      type: "button",
                      disabled: !$props.isEdited || $props.disabled || !meta.valid,
                      onClick: $setup.requestEmailVerification,
                      "aria-label": "이메일 인증요청"
                    }, _toDisplayString($setup.buttonTitle), 11 /* TEXT, CLASS, PROPS */, _hoisted_11))
              ]))
            : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */),
        (!!$props.parentKey)
          ? (_openBlock(), _createBlock($setup["DynamicSelect"], {
              key: 0,
              name: `${$props.name}_emailDomain`,
              class: "select-box",
              options: $setup.arrangedOptions,
              disabled: $props.disabled,
              error: $setup.isError(meta, validationErrorMsg),
              value: $setup.domainValue,
              "onUpdate:value": [
                _cache[1] || (_cache[1] = ($event: any) => (($setup.domainValue) = $event)),
                $setup.onChangeDomain
              ],
              onOnUpdatedOptions: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('onUpdatedOptions', $event)))
            }, null, 8 /* PROPS */, ["name", "options", "disabled", "error", "value"]))
          : _createCommentVNode("v-if", true),
        _withDirectives(_createElementVNode("p", { class: "message success" }, _toDisplayString($props.successMessage), 513 /* TEXT, NEED_PATCH */), [
          [_vShow, $props.successMessage]
        ]),
        _withDirectives(_createElementVNode("p", { class: "message error" }, _toDisplayString($props.errorMessage || validationErrorMsg), 513 /* TEXT, NEED_PATCH */), [
          [_vShow, $setup.isError(meta, validationErrorMsg)]
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["name", "rules", "modelValue"])
  ]))
}